import { Component } from '@angular/core';
import { AlsdeUser } from 'src/app/core/models/alsde-user.model';
import { Message } from 'src/app/core/models/message.model';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { MessageService } from 'src/app/core/services/message.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-dashboard-messages',
  templateUrl: './dashboard-messages.component.html',
  styleUrls: ['./dashboard-messages.component.scss']
})
export class DashboardMessagesComponent {

  messages: Message[] = [];
  user: AlsdeUser;
  isLoaderMsg = true;

  constructor(
    public messageService: MessageService, 
    private ls: LocalStorageService,
    private userService: UserService
  ) { 
    this.user = this.userService.getUser();
  }

  ngOnInit(): void {
    this.isLoaderMsg = true;
    const id = JSON.parse(this.ls.getItem('user'))?.alsdeId;
    this.messageService.getUnreadMessages('messages?userId='+id).subscribe({
      next: (res:any)=>{
        this.isLoaderMsg = false;
        if(res == null) return;
        this.messages = res.messages.filter((y:Message) => y.read == null).map((x:Message) => {
            x.link = 'message-center' ,
            x.linkName = 'Open Message Center',
            x.typeIcon = 'email';
            return x;
        }).sort((a:Message,b:Message)=>{
          return new Date(b.sent).getTime() - new Date(a.sent).getTime()
        });
      }, error: () => {
        this.isLoaderMsg = false;
      }
    });
  }
}
